/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleCharge
 */
export interface VehicleCharge {
    /**
     * 
     * @type {string}
     * @memberof VehicleCharge
     */
    name?: string;
    /**
     * Charge category (Tax, Surcharge, Fee, CDW, LDW, etc.)
     * @type {string}
     * @memberof VehicleCharge
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleCharge
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleCharge
     */
    percentage?: string;
    /**
     * Charge type (PerDay, Rental, Percent)
     * @type {string}
     * @memberof VehicleCharge
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleCharge
     */
    includedInRate?: boolean;
    /**
     * Whether this charge is an insurance or protection product (CDW, LDW, PAI, SLI, etc.)
     * @type {boolean}
     * @memberof VehicleCharge
     */
    isInsurance?: boolean;
}

/**
 * Check if a given object implements the VehicleCharge interface.
 */
export function instanceOfVehicleCharge(value: object): value is VehicleCharge {
    return true;
}

export function VehicleChargeFromJSON(json: any): VehicleCharge {
    return VehicleChargeFromJSONTyped(json, false);
}

export function VehicleChargeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleCharge {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'category': json['category'] == null ? undefined : json['category'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'type': json['type'] == null ? undefined : json['type'],
        'includedInRate': json['included_in_rate'] == null ? undefined : json['included_in_rate'],
        'isInsurance': json['is_insurance'] == null ? undefined : json['is_insurance'],
    };
}

export function VehicleChargeToJSON(json: any): VehicleCharge {
    return VehicleChargeToJSONTyped(json, false);
}

export function VehicleChargeToJSONTyped(value?: VehicleCharge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'category': value['category'],
        'amount': value['amount'],
        'percentage': value['percentage'],
        'type': value['type'],
        'included_in_rate': value['includedInRate'],
        'is_insurance': value['isInsurance'],
    };
}

